import React, { Component } from 'react'
import { t } from 'i18n'
import PropTypes from 'prop-types'
import InputGroup from 'Components/Forms/InputGroup'
import Textarea from 'react-autosize-textarea'
import ScoreIcon from 'Components/Base/ScoreIcon'

const i18nOpts = { scope: 'care_plan_creators.check_in_templates.questions' }

class MoodScaleQuestionOption extends Component {
  constructor(props) {
    super(props)

    const { questionOption } = props

    this.handleChange = this.handleChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)

    this.state = {
      id: questionOption.id,
      text: questionOption.data.text,
      description: questionOption.data.description || '',
      response: questionOption.data.response || '',
      index: questionOption.id || questionOption.data.index,
      order: questionOption.data.order,
      colorCode: questionOption.data.colorCode,
      score: questionOption.data.score,
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  }

  handleChange({ target: { name, value } }) {
    const currentState = this.state
    currentState[name] = value
    this.setState(currentState, () => {
      this.props.updateOptions(this.state)
    })
  }

  render() {
    const { text, description, score, colorCode, response } = this.state
    const error = text.length ? null : this.props.errors['check_in_question_options.text']
    const { isActive, maxDesc, maxTitle, renderConditionalResponse } = this.props

    return (
      <li>
        <div className="option-input-wrapper">
          <div className="option-index">{score}</div>

          <div className="option-inputs">
            <div>
              <InputGroup
                component="input"
                name="text"
                placeholder={t('placeholders.mood_scale_text', i18nOpts)}
                value={text}
                onChange={this.handleChange}
                required
                maxLength={maxTitle}
                className="option-text"
                type="text"
                errors={{ text: error }}
                readonly={isActive}
              />
              <span className="character-count">{maxTitle - text.length}</span>
            </div>
            <div>
              <Textarea
                component="input"
                name="description"
                placeholder={t('placeholders.mood_scale_description', i18nOpts)}
                value={description}
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
                maxLength={maxDesc}
                className="option-description"
                readonly={isActive}
              />
              <span className="character-count-big">{maxDesc - (description || '').length}</span>
            </div>
            {renderConditionalResponse(response, this.handleChange)}
          </div>

          <div className="option-icon">
            <ScoreIcon score={score} background={colorCode} />
          </div>
        </div>
      </li>
    )
  }
}

MoodScaleQuestionOption.propTypes = {
  errors: PropTypes.object,
  isActive: PropTypes.bool,
  maxDesc: PropTypes.number,
  maxTitle: PropTypes.number,
  questionOption: PropTypes.object,
  renderConditionalResponse: PropTypes.func.isRequired,
  updateOptions: PropTypes.func,
}

MoodScaleQuestionOption.defaultProps = {
  errors: {},
  isActive: false,
  maxDesc: 110,
  maxTitle: 25,
  questionOption: {},
  updateOptions: null,
}

export default MoodScaleQuestionOption
